import {
	hideMeterReadingLimit,
	hideUpdateRequests,
} from 'plugins/router/routes/global'
import { hideReports } from 'plugins/router/routes/reports.ts'
import routesLimited from 'constants/routesLimited.ts'
import { castRouteIds } from 'plugins/router/routes/castRouteIds.ts'
import type { RouteWithParams } from 'plugins/router/types.ts'
import type { RouteRecordRaw } from 'vue-router'
import { aliases } from '../aliases'

const pendingReport = {
	component: () =>
		import('components/modules/PendingRequests/Reports/Report.vue'),
	name: 'pendingReport',
	path: ':id',
	alias: aliases.admin_report,
	props: (route: RouteWithParams) => {
		return {
			id: parseInt(route.params.id),
			imagePreviewRouteName: 'pendingReportImagePreview',
			pdfPreviewRouteName: 'pendingReportPDFPreview',
		}
	},
}

const pendingReports = {
	children: [pendingReport],
	component: () =>
		import('components/modules/PendingRequests/Reports/ReportKanban.vue'),
	meta: {
		icon: 'fa-solid fa-ticket',
		title: 'routeTitle.reports',
		nav: false,
	},
	path: 'reports',
	name: 'pendingReports',
	props: true,
}

const personUpdaterequest = {
	component: () =>
		import('components/modules/PendingRequests/UpdateRequests/Approve.vue'),
	name: 'approveUpdaterequest',
	path: ':id',
	alias: aliases.update_request,
	meta: {
		title: 'Änderung bestätigen / ablehnen',
		subs: [routesLimited.subMethods.notification_person_update],
	},
	props: castRouteIds,
}

const personUpdateRequests = {
	children: [personUpdaterequest],
	component: () =>
		import('components/modules/PendingRequests/UpdateRequests/List.vue'),
	meta: {
		icon: 'fas fa-user-edit',

		nav: false,
		title: 'entity.updaterequest.name',
		subtitle: '',
		hidden: hideUpdateRequests,
		subs: [routesLimited.subMethods.notification_person_update],
	},
	name: 'updaterequests',
	path: 'updaterequests',
}

const adminMeters = {
	component: () => import('components/modules/PendingRequests/Meters/List.vue'),
	name: 'adminMeters',
	path: 'meters',
	meta: {
		icon: 'fas fa-tachometer-alt',
		hidden: hideMeterReadingLimit,
		nav: false,
		title: 'entity.meter.name',
		subs: [routesLimited.subModules.meters],
	},
	children: [
		{
			name: 'administrationMeterDetails',
			component: () =>
				import('components/modules/PendingRequests/Meters/LevelRelease.vue'),
			path: ':meterId/:id',
			props: castRouteIds,
		},
	],
}

export const pendingRequests: RouteRecordRaw = {
	children: [pendingReports, personUpdateRequests, adminMeters],
	component: () =>
		import('components/modules/PendingRequests/PendingRequests.vue'),
	meta: {
		hidden: [hideMeterReadingLimit, hideUpdateRequests, hideReports],
		icon: 'fas fa-messages-question',

		nav: true,
		tour: true,
		auth: true,
		ordering: 9,
		title: 'routeTitle.openRequests',
		limited: [routesLimited.isAdminOrTeam],
		subs: [routesLimited.subModules.reports],
	},
	path: '/pending_requests',
	name: 'pendingRequests',
}

export const pendingRequestsRoutes = [
	adminMeters,
	personUpdateRequests,
	pendingRequests,
]
